import React, { useCallback, useState } from 'react';
import PersonIcon from '@mui/icons-material//Person';
import { styled } from '@mui/material';
import { Tooltip } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { firmUserManagementUrl } from 'common/config/urls';
import theme from 'theme';
import ConfirmationDialog from './ConfirmationDialog';

const PREFIX = 'CompanyUserIconAndRedirectionButton';

const classes = {
  icon: `${PREFIX}-icon`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.icon}`]: {
    color: theme.palette.grey[500],
    fontSize: '1.25rem',
    marginRight: '0.5rem',
    cursor: 'pointer',
  },
});

interface Props {
  usersEmails: string[];
}

const CompanyUserIconAndRedirectionButton = ({ usersEmails }: Props) => {
  const [open, setOpen] = useState(false);
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();
  const navigate = useNavigate();

  const handleIconClick = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(
    (confirm: boolean) => {
      setOpen(false);
      if (confirm) {
        navigate(firmUserManagementUrl(firmSlugParam));
      }
    },
    [firmSlugParam, navigate]
  );

  return (
    <Root>
      <Tooltip title={usersEmails} placement="top">
        <PersonIcon className={classes.icon} onClick={handleIconClick} />
      </Tooltip>
      <ConfirmationDialog open={open} onClose={handleClose} />
    </Root>
  );
};

export default CompanyUserIconAndRedirectionButton;
